import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { logout } from 'auth/actions';

import { getUser } from 'auth/selectors';
import LoaderFull from 'components/layout/LoaderFull';

class LogoutContainer extends Component {
  componentWillMount = () => this.props.logout();

  render = () => (this.props.user ? <LoaderFull /> : <Redirect to={'/'} />);
}

const mapStateToProps = (state) => ({ user: getUser(state) });
const mapDispatchToProps = { logout };

export default connect(mapStateToProps, mapDispatchToProps)(LogoutContainer);



// WEBPACK FOOTER //
// src/modules/auth/containers/LogoutContainer.js